import { BaseModel } from './BaseModel';
import Section from './Section';
export class UserEnrollment extends BaseModel {
  static get entity() {
    return 'user-enrollments';
  }

  static get fk() {
    return 'user_enrollment_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      uid: this.attr(''),
      enrolled_at: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      section_id: this.attr(null),
      section: this.belongsTo(Section, 'section_id')
    };
  }

  static apiConfig = {
    actions: {
      async fetchAll() {
        return this.get(`/user-enrollments`);
      },
      async fetchByParams(params) {
        return this.get(`/user-enrollments`, {
          params
        });
      },
      async fetchById(uid, start, limit) {
        return this.get(`/user-enrollments/userid/${uid}?_start=${start}&_limit=${limit}`, {
          save: false
        });
      },
      async handleEnroll(body) {
        return this.post('/user-enrollments/enrolling-section-lu', {
          ...body
        });
      }
    }
  };
}

export default UserEnrollment;
